import React from "react";
import {formatDate} from "../../utils/helpers";

/** @import {Account} from "../../contexts/CustomerDataProviderTypes" */

export const exceedsMaxBalance = (/** @type {Account | null| undefined} */ maturingAccount) => {
    if (maturingAccount && maturingAccount.maturity && maturingAccount.product && maturingAccount.product.maxWithdrawalLimit) {
        return maturingAccount.maturity.calculatedBalanceAtMaturity > maturingAccount.product.maxWithdrawalLimit
    }
    return false;
}

export const formatter = (/** @type {string} */ date) => {
    if (date) {
        return formatDate(new Date(date), {shortMonth:true, padDay:true});
    }
    return '';
}

export const constructDateTime = (/** @type {Date} */ date, /** @type {string | undefined} */ time) => {
    // closure time is passed through graphQL as a separate string to prevent value being lost during conversion from
    // c# DateTime
    const timeList = time ? time.match(/\d{2}/g) : '';
    const [hours, minutes] = timeList ? [parseInt(timeList[0], 10), parseInt(timeList[1], 10)] : [0, 0];
    return new Date(new Date(date).setHours(hours, minutes))
}

export const renderOfferRate = (/** @type {number} */ ntbInterestRate, /** @type {number} */ rolloverRate) => {
    const displayNtBRate = ntbInterestRate > rolloverRate;
    const offerRate = displayNtBRate ? ntbInterestRate : rolloverRate.toFixed(2);

    return (
        <div className={"maturity-renewal-rates__rate"} data-renewal-offer-rate={offerRate}><b>{offerRate}% AER*</b></div>
    )
}

export const renderOfferDetail = (/** @type {number} */ ntbInterestRate, /** @type {number} */ rolloverRate) => {
    const displayNtBRate = ntbInterestRate > rolloverRate
    return displayNtBRate ?
        <>
            <div className={"maturity-renewal-rates__detail"}>From today, you’ll receive our new customer rate, which is currently higher than our renewal rate of <b>{rolloverRate.toFixed(2)}% AER*</b>.</div>
            <div className={"maturity-renewal-rates__detail"}>Rest assured, we’ll always offer you our highest rate on the day your account matures.</div>
        </>
        :
        <>
            <div className={"maturity-renewal-rates__detail"}>You’ll receive our <b>renewal rate</b>, which is currently higher than or equal to our new customer rate of <b>{ntbInterestRate}% AER*</b>.</div>
            <div className={"maturity-renewal-rates__detail"}>We’ll always offer you our highest rate on the day your account matures.</div>
        </>
}